export enum STREAM_STATUS {
  NOT_STARTED = 'NotStarted',
  STARTED = 'Started',
  ENDED = 'Ended'
}
